import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as actions from "../../actions/EmailAuthenticationActions";
import { requiredValue } from "../validation/AccountValidations";
import UrlHelper from "../../utilities/UrlHelper";
import { loginSteps } from "../../utilities/Constants";
import { isEnterPressed } from "../../utilities/EventsHelper";

export class CheckPassword extends Component {
    constructor (props) {
        super(props);
        this.state = {
            password: undefined,
            validationError: undefined
        };

        this.onPasswordChange = this.onPasswordChange.bind(this);
        this.onEnter = this.onEnter.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.onResetPassword = this.onResetPassword.bind(this);
        this.textInput = null;
        this.divEl = null;

        this.setTextInputRef = element => {
            this.textInput = element;
        };

        this.setDivRef = ref => { this.divEl = ref; };

        this.focusTextInput = () => {
            // Focus the text input using the raw DOM API
            if (this.textInput) this.textInput.focus();
        };

        this.onTransitionEnd = this.onTransitionEnd.bind(this);
    }

    onPasswordChange (e) {
        if (e && e.target)
            this.setState({ password: e.target.value });
    }

    componentDidMount() {
        if (this.divEl) {
            this.divEl.addEventListener('transitionend', this.onTransitionEnd, false);
        }
    }
    componentWillUnmount() {
        if (this.divEl) {
            this.divEl.removeEventListener('transitionend', this.onTransitionEnd);
        }
    }

    onTransitionEnd () {
        if (this.props.step === loginSteps.enterPassword) {
            setTimeout(() =>this.focusTextInput(), 100);
        }
    }

    onEnter (e) {
        if (isEnterPressed(e))
            this.onComplete();
    }

    onComplete () {
        const validationResult = requiredValue(this.state.password);
        if (validationResult.isValid) {
            const productCode = UrlHelper.getProductCodeFromUrl();
            const returnUrl = UrlHelper.getReturnUrl();

            this.setState({ validationError: undefined });
            this.props.completeEmailLogin(this.props.email, this.state.password, productCode, returnUrl);
        }
        else
            this.setState({ validationError: validationResult.error });
    }

    onResetPassword () {
        this.props.passwordReset(this.props.email);
    }

    isSlideActive () {
        return this.props.step === loginSteps.enterPassword;
    }

    render () {
        const validationError = this.state.validationError;

        const isActive = this.isSlideActive();
        const blockClassName = isActive ? "slide slide-active" : "slide";
        const inputTabIndex = isActive ? 0 : -1;
        const linkTabIndex = isActive ? 1 : -1;

        if (this.props.step !== loginSteps.enterEmail && this.props.step !== loginSteps.enterPassword)
            return null;

        return (
            <div className={blockClassName} ref={this.setDivRef}>
                <div>
                    <div className="loginEmail-popup" name="enterPassword">
                        <div className="signIn-form-title">Enter Password</div>
                        <div className="signIn-form-subtitle">
                            <span className="email email-link" onClick={this.props.backToEmailForm}>
                                <i className="material-icons">arrow_back</i>
                                <span>{this.props.email}</span>
                            </span>
                        </div>

                        <div className="input-row">

                            {/* DO NOT CHANGE TO TEXTINPUT - needs to focus on this input after enter email !!!!  */}
                            <input
                                id="passwordInput"
                                placeholder="Enter Password"
                                type="password"
                                name="password"
                                tabIndex={inputTabIndex}
                                className="picker-hollow"
                                onChange={this.onPasswordChange}
                                onKeyUp={this.onEnter}
                                ref={this.setTextInputRef}
                            />

                            {validationError && <div className="validate-error-message">{validationError}</div>}
                        </div>
                        <div className="button-container">
                            <button id="btnCheckPasswordSignIn" className="btn btn-primary-action pull-right"
                                onClick={this.onComplete} tabIndex={inputTabIndex}>
                                Sign In
                            </button>
                        </div>

                        <div className="resetPassword-link">
                            <a onClick={this.onResetPassword} href="#" tabIndex={linkTabIndex}>Reset Password</a>
                        </div>
                    </div>
                </div>
            </div>);
    }
}

CheckPassword.propTypes = {
    email: PropTypes.string,
    backToEmailForm: PropTypes.func,
    passwordReset: PropTypes.func,
    completeEmailLogin: PropTypes.func,
    step: PropTypes.string
};

const mapStateToProps = state => ({
    email: state.loginState.email,
    step: state.loginState.loginStep
});

export const mapDispatchToProps = (dispatch) => {
    return ({
        backToEmailForm: () => dispatch(actions.backToEmailForm()),
        passwordReset: (email) => dispatch(actions.goToPasswordReset()),
        completeEmailLogin: (email, password, productCode, returnUrl) => dispatch(actions.completeEmailLogin(email, password, productCode, returnUrl))
    });
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckPassword);
